// src/config/appConfig.js
const appConfig = {
  company: {
    name: "Shikitari Japanese Language Academy",
    tagline: "しきたり日本語学院",
  },
  contact: {
    nepal: {
      position: "Nepal Representative",
      phoneRaw: "+977061571800",
      phoneDisplay: "+977 061 571 800",
      address: "Sabhagriha Chowk 8 Pokhara, Nepal",
      address2: "सभागृह चोक ८ पोखरा, नेपाल",
      email: "sikitari25@gmail.com",
    },
    japan: {
      position: "Japan Representative",
      phone1Raw: "+8108096424594",
      phone1Display: "+81 080 9642 4594",
      phone2Raw: "+8108099696743",
      phone2Display: "+81 090 9969 6743",
      address: "Tokyo, Japan", // Consider adding a more specific address if available
    },
  },
  social: {
    facebook: "https://www.facebook.com/people/Shikitari-Acadamy/pfbid02NWzJ7AvdDrjRUbWMrMAi9GvGxDo9xyTNv3ZURa3pPKrdsCeeki6N5ikLtFrpm2nnl/",
    instagram: "https://instagram.com/yourinstagram", // !!! IMPORTANT: REPLACE WITH YOUR ACTUAL INSTAGRAM URL !!!
    whatsapp: "https://wa.me/9779856072299", // !!! IMPORTANT: REPLACE WITH YOUR ACTUAL WHATSAPP NUMBER (no + in wa.me link) !!!
    line: "https://line.me/ti/p/yourlineid", // !!! IMPORTANT: REPLACE WITH YOUR ACTUAL LINE ID URL !!!
  },
  // Dynamic year for copyright
  currentYear: new Date().getFullYear(),
};

export default appConfig;